import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeABTesting, getLandingPageVariant, logExperimentView } from '../firebase';
import mixpanel from 'mixpanel-browser';

const ABTestWrapper = ({ children, variantA, variantB }) => {
  const [variant, setVariant] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const setupABTest = async () => {
      // Check for variant override in URL (?variant=A or ?variant=B)
      const params = new URLSearchParams(location.search);
      const variantOverride = params.get('variant')?.toUpperCase();
      
      let selectedVariant;
      if (variantOverride === 'A' || variantOverride === 'B') {
        selectedVariant = variantOverride;
      } else {
        await initializeABTesting();
        selectedVariant = getLandingPageVariant();
      }

      // Set the variant
      setVariant(selectedVariant);

      // Log the experiment view
      console.log('ABTestWrapper - Logging experiment view for variant:', selectedVariant);
      
      // Track in Mixpanel
      mixpanel.track('Open Landing Page', {
        variant: selectedVariant,
        experiment: 'landing_page_test'
      });
      mixpanel.identify();
      mixpanel.people.set();
      
      // Set user properties
      const tolt_referral = window.tolt_referral;
      mixpanel.people.set_once({
        utm_source: mixpanel.get_property('utm_source'),
        utm_medium: mixpanel.get_property('utm_medium'), 
        utm_campaign: mixpanel.get_property('utm_campaign'),
        utm_term: mixpanel.get_property('utm_term'),
        search_engine: mixpanel.get_property('$search_engine'),
        search_keyword: mixpanel.get_property('mp_keyword'),
        referrer: mixpanel.get_property('$referrer'),
        initial_referrer: mixpanel.get_property('$initial_referrer'),
        tolt_referral: tolt_referral,
      });
      
      // Track in Firebase
      logExperimentView(selectedVariant);
      
      setIsLoading(false);
    };

    setupABTest();
  }, [location]);

  if (isLoading) {
    return null; // Or a loading spinner
  }

  return variant === 'A' ? variantA : variantB;
};

export default ABTestWrapper;